export default __webpack_public_path__ + "static/media/usp_1.87de7c98.svg";